import cn from "classnames";
import { FC, PropsWithChildren } from "react";

interface CardItemProps {
  empty?: boolean;
}

const CardItem: FC<PropsWithChildren<CardItemProps>> = ({
  children,
  empty,
}) => {
  return (
    <>
      <article
        className={cn(
          "flex flex-row h-[80px]  w-full lg:h-[65px]  justify-between items-center pl-4 gap-2 lg:gap-4 pr-6 py-3 bg-white rounded-md",
          {
            "justify-between items-center flex-row bg-white": !empty,
          },
        )}
      >
        <>{children}</>
      </article>
    </>
  );
};

export default CardItem;
